import { memo as Memo } from 'react';

//* Components
import Image from '@components/global/Image';
import Video from '@components/cfModules/Video';

//* Styles
import SingleImageStyle from './style';

const SingleImage = Memo(({ data }) => {
	return (
		<SingleImageStyle className={'imageWrap'}>
			{data.image.fields.file.contentType !== 'video/mp4' ? (
				<Image
					src={data.image.fields.file.url}
					alt={data.image.fields.title}
					className={data.position}
				/>
			) : (
				<Video data={data.image.fields.file.url} />
			)}
		</SingleImageStyle>
	);
});

export default SingleImage;
